import homeImage1 from "../Assets/images/home-image-1.jpg";
import homeImage2 from "../Assets/images/home-image-2.png";
import homeImage3 from "../Assets/images/home-image-3.png";
import homeImage4 from "../Assets/images/home-image-4.png";
import homeImage5 from "../Assets/images/home-image-5.png";
import homeImage6 from "../Assets/images/home-image-6.png";
import homeImage7 from "../Assets/images/home-image-7.png";
import homeImage8 from "../Assets/images/home-image-8.png";
import homeImage9 from "../Assets/images/home-image-9.png";
import homeImage10 from "../Assets/images/home-image-10.png";
import homeImage11 from "../Assets/images/home-image-11.png";

// Data for the home page including title, text, SEO keywords, and grid images
const homePageData = {
  czech: {
    title: "Robert Tichý – Výroba houslí",
    text: "Dobrý den, jmenuji se Robert Tichý a jsem pokračovatelem houslařské rodinné tradice již ve druhé generaci. Nabízím vám své housle, violy, violoncella a violy da gamba, ve kterých se snoubí tradice a vášeň pro řemeslo.",
    seoKeywords: "Objevte krásné nástroje vyrobené s pečlivostí a láskou.",
  },
  english: {
    title: "Crafting Violins by Robert Tichý",
    text: "Hello, my name is Robert Tichy, and I am continuing the family tradition of violin making into the second generation. I offer you my violins, violas, cellos, and violas da gamba, where tradition blends with a passion for the craft.",
    seoKeywords: "Discover beautiful instruments crafted with care and love.",
  },
  spanish: {
    title: "Robert Tichy – Artesanía de Violines",
    text: "Hola, mi nombre es Robert Tichý y soy la segunda generación de la tradición familiar de la luthería. Les ofrezco mis violines, violas, violonchelos y violas da gamba, que combinan tradición y pasión por la artesanía.",
    seoKeywords: "Descubre hermosos instrumentos hechos con cuidado y amor.",
  },
  french: {
    title: "Robert Tichy – Artisanat des Violons",
    text: "Bonjour, je m'appelle Robert Tichý et je suis la deuxième génération de la tradition familiale des luthiers. Je vous propose mes violons, violes, violoncelles et violes de gambe, qui allient tradition et passion de l'artisanat.",
    seoKeywords:
      "Découvrez de magnifiques instruments fabriqués avec soin et amour.",
  },
  gridImages: [
    homeImage1,
    homeImage2,
    homeImage3,
    homeImage4,
    homeImage5,
    homeImage6,
    homeImage7,
    homeImage8,
    homeImage9,
    homeImage10,
    homeImage11,
  ], // Array of images for the grid on the home page
};

export default homePageData;
